import { fabric } from "fabric";
import { FabricObject } from "../../../types/FabricCustomType";

export interface CreateSeatShapeParams {
  left: number;
  top: number;
  rowSeatSize: number;
  defaultSeatColor: string;
  editable?: boolean;
  isPreview?: boolean;
  id?: string;
  label?: string;
  displayedLabel?: string;
  container?: string;
  objectOption?: any;
  angle?: number;
}

export class SeatShapeFactory {
  static readonly STROKE_WIDTH = 1;

  static getOuterDiameter(rowSeatSize: number): number {
    return rowSeatSize + SeatShapeFactory.STROKE_WIDTH;
  }

  static createSeatShape({
    left,
    top,
    rowSeatSize,
    defaultSeatColor,
    editable = true,
    isPreview = false,
    id,
    label = "Label",
    displayedLabel = "",
    container,
    objectOption,
    angle = 0,
  }: CreateSeatShapeParams) {
    const shape = new fabric.Circle({
      name: "Seat",
      left,
      top,
      originX: "center",
      originY: "center",
      radius: rowSeatSize / 2,
      angle,
      fill: `${defaultSeatColor}40`,
      strokeWidth: SeatShapeFactory.STROKE_WIDTH,
      stroke: defaultSeatColor,
      transparentCorners: false,
      hasBorders: editable,
      selectable: true,
      lockMovementX: !editable,
      lockMovementY: !editable,
      opacity: isPreview ? 0.4 : 1,
    }) as FabricObject<fabric.Circle>;

    shape.set({
      id,
      label,
      displayedLabel,
      container,
      editable,
      objectOption,
    });

    return shape;
  }
}
